import React, {useEffect, useState} from 'react';
import {Popup} from "../../ui/popup/popup";
import {sendGAEvent} from "../../domain/marketing/gtm-provider";
import { getGdprCookie, getGdprError } from '../gdpr/domain/gdpr-provider';

interface IVideoPopUp {
   youtubeCode: string,
    youtubeTitle: string,
    youtubeAutoplayHash: string,
    $button: HTMLElement,
}

/**
 * the entry point
 */
const VideoPopUp = (props: IVideoPopUp) => {
    //console.log('youtubeAutoplayHash | window.location.hash', props.youtubeAutoplayHash,window.location.hash);
    const [showPopup, setShowPopup] = useState(
        props.youtubeAutoplayHash != '' && window.location.hash === `#video-${props.youtubeAutoplayHash}`
    );
    const ytCode = `https://www.youtube.com/embed/${props.youtubeCode}?rel=0;showinfo=0;wmode=opaque;
        cc_load_policy=1;iv_load_policy=;autohide=1;fs=1;origin=https://www.waves.com;enablejsapi=1`;

    const gdpr = getGdprCookie();
    const isFunctional = gdpr.IsFunctional;

    var ytTitle = 'Watch now';
    if(props.youtubeTitle && props.youtubeTitle !== '')
        ytTitle = `Watch about ${props.youtubeTitle}`;

    useEffect(() => {
        /**
         * reopen popup on button click
         */
        const handleButtonClick = () => {
            //console.log('VideoPopUp click');
            setShowPopup(true);
            sendGAEvent('Product Page Main Video', 'open video')
        };

        props.$button.addEventListener('click', handleButtonClick);

        return () => {
            props.$button.removeEventListener('click', handleButtonClick);
        };
    }, [props.$button]);

    return (
        <div
            className="mx-4"
            data-abc={showPopup.toString()}>
            {
                showPopup &&
                <Popup
                    width={isFunctional ? '1400px' : '650px'}
                    height={'900px'}
                    canBeClosed={true}
                    bgClass={'bg-transperent'}

                    classes="py-12 lg:px-12"
                    /*styles={{'padding':'3rem'}}*/
                    iconWidth='30'
                    close={() => {
                        setShowPopup(false);
                    }}>
                    {
                        isFunctional &&
                        <div className="relative" style={{paddingTop: '56.25%'}}>
                            <iframe className="absolute inset-0 w-full h-full"
                                    id='ytplayer'
                                    title={ytTitle}
                                    src={ytCode}
                                    frameBorder="0"
                                    allowFullScreen
                                    allow='autoplay'>
                            </iframe>
                        </div>
                    }

                    {
                        !isFunctional &&
                        <div
                            className="flex-1 items-center flex"
                            dangerouslySetInnerHTML={{ __html: getGdprError() }}
                        />
                    }
                </Popup>
            }
        </div>
    )
};

export default VideoPopUp;